import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js";
import { invokeGetService, invokePostService, handleSnackBar } from "../../../store/global/actions";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { Box, Grid } from '@material-ui/core';
import { getUtNestedData, customizeUtExtensionForm, userTriggerSchema, convertToCustomArray } from '../../../services/entities/user_triggers.js'
import { getUserTriggerSchema } from '../../../config/simulation.js';
import { useBottomDrawer } from '../../../hooks/useBottomDrawer.js';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import './style.css';
import { getElementOnFocus } from '../../../store/global/selectors.js';

const options = {
    form_name_root: "utriggers",
    show_errors: "never",
    disable_array_add: true,
    disable_array_delete: true,
    disable_array_reorder: true,
    disable_properties: false,
    no_additional_properties: false,
    keep_oneof_values: false
}


export default function ExtendUTFields({ userTriggerId, onClose, onCompletion, setUTExtensionFileds}) {

    console.log("Test1230-------", { userTriggerId, onClose, onCompletion, setUTExtensionFileds})

    const dispatch = useDispatch();
    const bottomDrawer = useBottomDrawer();
    const elementOnFocus = useSelector(getElementOnFocus);
    console.log("ElmntonFocus-----", elementOnFocus)
    

    const [schemaValues, setSchemaValues] = useState({});
    const [loading, setLoading] = useState(false);
    const [allFields, setAllFields] = useState([]);
    const [sections, setAllSections] = useState([]);
    const [editorSchema, setEditorSchema] = useState({});
    const [formData, setFormData] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);

    const [fields, setFields] = useState([]);
    const [events, setEvents] = useState([]);
    let [userTriggers, setUserTriggers] = useState([]);
    const [clusterlets, setClusterlets] = useState([]);

    const [selectedUserTrigger, setSelectedUserTrigger] = useState(null)
    const [selectedFields, setSelectedFields] = useState([])
    const [typeClusterlet, setTypeClusterlet] = useState(null)
    const [typeClusterletName, setTypeClusterletName] = useState('');

    useEffect(() => {
        loadUserTriggerData();
    }, [])

    const loadUserTriggerData = () => {
        setLoading(true)

        dispatch(invokeGetService('getSingleUT', [userTriggerId]))
            .then((response) => {
                if (response.data !== undefined) {
                    setFields(response.data.fields)
                    setEvents(response.data.events)
                    setUserTriggers(response.data.userTriggers)
                    setClusterlets(response.data.clusterlets)

                    let selUt = response.data.userTriggers.find(item => item._id == userTriggerId)
                    setSelectedUserTrigger(selUt)

                    let userTriggerEvent = response.data.events.find(item => item._id === selUt.attributes.op)
                    setSelectedFields(response.data.fields.filter(item => item.parent[0].id == selUt._id || item.parent[0].id == userTriggerEvent.message))

                    let typeCl = response.data.clusterlets.find(c => c._id == selUt?.attributes?.type)
                    setTypeClusterlet(typeCl)
                    setTypeClusterletName(typeCl !== undefined ? typeCl.name : '')

                    let modifiedFields = response.data.fields.filter(item => item.parent[0].id == selUt._id || item.parent[0].id == userTriggerEvent.message).map(item => {
                        return {
                            ...item,
                            name: item.parent[0].type === 'user_trigger' ? `Target ${typeClusterletName} Instance` : item.name
                        }
                    })
                    findUserTriggerSchema(selUt, response.data.fields, modifiedFields, response.data.messages);
                    dealUtSchemaData(selUt, response.data.fields, modifiedFields, response.data.messages);



                }else{

                }
                setLoading(false)

            })

    }

    const findUserTriggerSchema = (userTrigger, allFields, utFields, messages) => {

        let schema = { ...userTriggerSchema };

        let nestedUtStructure = getUtNestedData(utFields, allFields, messages);
        const utSchemaResp = getUserTriggerSchema(nestedUtStructure);

        schema = { ...schema, properties: { ...schema.properties, ...utSchemaResp } };

        console.log('schem----ut-----', schema)

        setEditorSchema(schema);

    }

    const transformStructure = (inputStructure, userTrigger, fields) => {
        const result = {};

        function processChildren(children, obj) {
            children.forEach(child => {

                const childName = child.name;

                if (child.children && child.children.length > 0 || child.attributes.type == "struct") {
                    obj[childName] = {}
                    processChildren(child.children, obj[childName]);
                } else {
                    let fieldVal = userTrigger?.extensions.find(fd => fd.field == child._id)
                    obj[childName] = {
                        field: '',
                        type: fieldVal?.type ? fieldVal?.type : child?.attributes?.type ? child.attributes.type.toLowerCase() : '',
                        value: fieldVal?.default ? fieldVal?.default : '',
                        nodeId: child._id ? child._id : ""
                    };
                }
            });
        }

        inputStructure.forEach(section => {

            const sectionName = section.name;
            result[sectionName] = {};


            if (section.children && section.children.length > 0 || section.attributes.type == "struct") {
                processChildren(section.children, result[sectionName]);
            }
            else {
                let fieldVal = userTrigger?.extensions.find(fd => fd.field == section._id)
                result[sectionName] = {
                    field: '',
                    type: fieldVal?.type ? fieldVal?.type : section?.attributes?.type ? section.attributes.type.toLowerCase() : '',
                    value: fieldVal?.default ? fieldVal?.default : '',
                    nodeId: section._id ? section._id : ""
                };
            }
        });

        return result;
    }

    const dealUtSchemaData = (userTrigger, allFields, utFields, messages) => {

        let schemaData = {};

        let nestedUtStructure = getUtNestedData(utFields, allFields, messages);
        const payloadschemaData = transformStructure(nestedUtStructure, userTrigger, allFields);
        console.log('payloadschemaData----', payloadschemaData)

        schemaData['payload'] = payloadschemaData

        setSchemaValues(schemaData)


    }

    const onChangeJsonEditor = (data) => {


        setFormData(data);

        customizeUtExtensionForm(data);

        if(setUTExtensionFileds != undefined){
            let extensions = convertToCustomArray(data?.payload);
            setUTExtensionFileds(extensions)

        }


    }

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };



    const onUpdateEvent = () => {
        setIsUpdating(true)

        let extensions = convertToCustomArray(formData?.payload);

        selectedUserTrigger.extensions = extensions;

        dispatch(invokePostService('editUserTrigger', { userTriggerData: selectedUserTrigger }, [selectedUserTrigger._id]))
            .then(savedData => {
                if (savedData.status) {
                    onCompletion("User trigger", 'edit')
                }
                else {
                    dispatch(handleSnackBar({ open: true, message: `Update extension failed`, severity: "error" }));
                }
                setIsUpdating(false)
            })
            .catch(error => console.error(error));

    }





    return (
        <>
            {loading ? <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '28vh' }} />
                : (
                    <>
                        {bottomDrawer && elementOnFocus != undefined && elementOnFocus.type != "event" && (
                            <Box display="flex" justifyContent="flex-end" sx={{ position: 'relative' }}>
                                <Button onClick={onClose} disabled={isUpdating || loading} className={`cancel_btn`} id={(`form_Cancel`).toLowerCase()} startIcon={<ArrowBackIcon/>} size={"small"} color="primary" variant="contained" style={{ marginRight: 34, textTransform: 'capitalize', top:"40px", zIndex:1000 }}
                                    sx={{
                                        position: 'absolute',
                                      }}
                                >
                                    Back to List
                                </Button>
                            </Box>
                        )}
                        <JsonTableEditor options={options} schema={editorSchema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId="ut_editor" />
                    </>
                )
            }

            {setUTExtensionFileds == undefined && <Grid item xs={12} style={loading ? { display: "flex", justifyContent: "flex-end", marginBottom: 20, marginTop: "30vh" } : { display: "flex", justifyContent: "flex-end", marginTop: 30 }}>
                <UpdateCancel updateDisable={isUpdating || loading} content={isUpdating ? 'Updating..' : 'Update'} onUpdate={onUpdateEvent} onCancel={onClose} typesNotIn={['transaction', 'view', 'simulation']} />
            </Grid>}
        </>
    )



}